<tui-hosted-dropdown
    #codes
    [content]="codesDropdown"
>
    <button
        tuiIconButton
        type="button"
        size="s"
        icon="tuiIconCodeLarge"
        appearance="icon"
        tuiHintDirection="top-left"
        tuiHintDescribe
        [tuiHint]="hintText$ | async"
        [pseudoActive]="codes.open || (insideCode$ | async)"
        [focusable]="codes.open"
    ></button>
    <ng-template #codesDropdown>
        <tui-data-list>
            <button
                *ngFor="let item of codeOptionsTexts$ | async; let index = index"
                tuiOption
                (click)="onCode(!!index)"
            >
                {{ item }}
            </button>
        </tui-data-list>
    </ng-template>
</tui-hosted-dropdown>
